export default __webpack_public_path__ + "static/media/update.c8f50a82.svg";